import React, { useState } from 'react';
import useAuth from '../../auth/UseAuth';
import { isUndNullEmp, getLanguageObj, settings } from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';

export default function Header() {
    //#region variables
    const auth = useAuth();
    const [languageObj] = useState(GlobalFormats?.getClass(getLanguageObj({ subMethod: 'Header' })?.result));

    const [theme, setTheme] = useState(localStorage.getItem('crmerpintegrator.theme') || 'light');

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        localStorage.setItem('crmerpintegrator.theme', newTheme);
        if (newTheme === 'dark') {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    };
    //#endregion variables

    const { icons, labels } = settings;

    return (
        <nav className={`main-header navbar navbar-expand border-bottom-0 shadow-sm p-2 ${theme === 'dark' ? 'navbar-dark bg-dark' : 'navbar-white navbar-light'}`}>
            <div className='container-fluid px-0 px-md-3'>

                {/* Left navbar links */}
                <ul className='navbar-nav align-items-center'>
                    <li className='nav-item'>
                        <a className={`nav-link ${theme === 'dark' ? 'text-white' : 'text-dark'}`} data-widget='pushmenu' href='/#' role='button'>
                            <i className='fas fa-bars fa-lg' />
                        </a>
                    </li>
                    <li className='nav-item d-none d-md-inline-block'>
                        <a href='/' className='nav-link font-weight-bold text-muted px-3 hover-primary'>
                            {labels?.home?.[languageObj?.id]}
                        </a>
                    </li>
                    <li className='nav-item d-none d-md-inline-block'>
                        <a href='/contact' className='nav-link font-weight-bold text-muted px-3 hover-primary'>
                            {labels?.contact?.[languageObj?.id]}
                        </a>
                    </li>
                </ul>

                {/* Right navbar links */}
                <ul className='navbar-nav ml-auto align-items-center'>

                    {/* Theme Toggle */}
                    <li className='nav-item'>
                        <button className={`nav-link btn btn-link ${theme === 'dark' ? 'text-white' : 'text-dark'}`} onClick={toggleTheme} title={theme === 'light' ? 'Dark Mode' : 'Light Mode'}>
                            <i className={theme === 'light' ? icons?.fasFa?.moon : icons?.fasFa?.sun} />
                        </button>
                    </li>

                    {/* Navbar Search */}
                    <li className='nav-item'>
                        <a className={`nav-link ${theme === 'dark' ? 'text-white' : 'text-dark'}`} data-widget='navbar-search' href='/#' role='button'>
                            <i className={icons?.fasFa?.search} />
                        </a>
                        <div className='navbar-search-block bg-white shadow-sm border-0 py-2'>
                            <form className='form-inline container-fluid'>
                                <div className='input-group input-group-sm w-100'>
                                    <input className='form-control form-control-navbar bg-light border-0 py-3'
                                        type='search'
                                        placeholder={labels?.search?.[languageObj?.id] || 'Search...'}
                                        aria-label='Search'
                                        style={{ borderRadius: '5px 0 0 5px' }} />
                                    <div className='input-group-append'>
                                        <button className='btn btn-navbar bg-light border-0' type='submit'>
                                            <i className={icons?.fasFa?.search} />
                                        </button>
                                        <button className='btn btn-navbar bg-light border-0' type='button' data-widget='navbar-search' style={{ borderRadius: '0 5px 5px 0' }}>
                                            <i className={icons?.close} />
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </li>

                    {/* Notifications (Conditional) */}
                    {!isUndNullEmp({ data: auth, subMethod: 'Header - checkAuth', })?.result && auth?.isLoged({ subMethod: 'Header - isLoged' })?.result ? (
                        <li className='nav-item dropdown px-2'>
                            <a className={`nav-link position-relative ${theme === 'dark' ? 'text-white' : 'text-dark'}`} data-toggle='dropdown' href='/#'>
                                <i className='far fa-bell fa-lg' />
                                <span className='badge badge-danger navbar-badge shadow-sm' style={{ top: '5px', right: '5px' }}>15</span>
                            </a>
                            <div className='dropdown-menu dropdown-menu-lg dropdown-menu-right border-0 shadow-lg rounded-lg pt-0'>
                                <span className='dropdown-item dropdown-header bg-light rounded-top font-weight-bold py-3'>15 {labels?.notifications?.[languageObj?.id] || 'Notifications'}</span>
                                <div className='dropdown-divider m-0' />
                                <a href='/#' className='dropdown-item py-3'>
                                    <i className='fas fa-envelope mr-2 text-primary' /> 4 new messages
                                    <span className='float-right text-muted text-sm'>3 mins</span>
                                </a>
                                <div className='dropdown-divider m-0' />
                                <a href='/#' className='dropdown-item py-3 text-center text-primary font-weight-bold'>
                                    {labels?.seeAllNotifications?.[languageObj?.id] || 'See All Notifications'}
                                </a>
                            </div>
                        </li>
                    ) : (<div></div>
                    )}

                </ul>
            </div>
        </nav>
    );
}